
import { ResourceSource } from "@/services/resourceWatcherService";
import { buildAnchorUrl } from "@/utils";
import { ResourceType } from "@/utils/watcher";
import { defineComponent } from "vue";

export default defineComponent({
	props: {
		resourceType: {
			type: String as () => ResourceType,
			required: true,
		},
		source: {
			type: Object as () => ResourceSource,
			required: true,
		},
	},
	setup() {
		return { ResourceType, buildAnchorUrl };
	},
});
